// extracted by mini-css-extract-plugin
export default {"holder":"Applications_holder__jkgG7"};